import { TChatCompletionMessageParam, TChatBotReq } from "@sharedTypes/req.type";
import { TChatBotRes } from "@sharedTypes/res.type";
import missingParametersError from "api/Error";
import axios from "axios";

export default async function ChatBot(messages: TChatCompletionMessageParam[]) {
  const apiUrl = "/tools/chatbot/chatbot";

  const body: TChatBotReq = {
    messages: messages,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TChatBotRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
